import React, { lazy } from 'react';
import CanvasElement, { CanvasElementPcPropType } from '@editor/src/page/index/components/canvas/canvas-element-pc';
import LazyBoundary from '@com/LazyBoundary';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
const SelectBorder = lazy(() => import(/* webpackChunkName: "lazyComponents" */ '../../../../select-border-pc'));

interface ChartBorderElementType extends CanvasElementPcPropType {
    selectBorderStyle: any;
    draggable?: boolean;
}

class ChartBorderElement extends CanvasElement<ChartBorderElementType> {
    public constructor(props: ChartBorderElementType) {
        super(props);
    }

    public renderSelectBorder() {
        return this.shouldRenderBorderWithEditable()
            && <LazyBoundary>
                <SelectBorder
                    scale={this.props.scale}
                    frame={this.props.rect}
                    frameOnSlide={this.props.component.getFrame?.().frameOnSlide() ?? this.props.rect}
                    onDrag={this.props.onDrag}
                    onDragStart={this.props.onDragStart}
                    onDragStop={this.props.onDragStop}
                    borderDraggable={!!this.props.borderDraggable}
                    onBorderMouseDown={this.props.editable === true
                        ? this.props.onBorderMouseDown : undefined}
                    onBorderDoubleClick={this.props.editable === true
                        ? this.props.onBorderDoubleClick : undefined}
                    onBorderMouseUp={this.props.editable === true
                        ? this.props.onBorderMouseUp : undefined}
                    isSelected={!!this.props.isSelected}
                    pointerEvents={null}
                    relativeRotate={this.props.relativeRotate}
                    relativeFlipH={this.props.relativeFlipH}
                    relativeFlipV={this.props.relativeFlipV}
                    shouldRoundSize={this.props.component.type === UIModelType.SHAPE
                        || this.props.component.type === UIModelType.IMAGE}
                    style={this.props.selectBorderStyle}
                />
            </LazyBoundary>;
    }

    protected renderResizable() {
        return null;
    }
}

export default ChartBorderElement;
